import * as React from "react"
import Layout from "../components/Layout"
import Success from "../components/pages/home/Success"
import DynamicMarketing from "../components/pages/home/DynamicMarketing"
import Advantage from "../components/pages/home/Advantage"
import DigitalMarketing from "../components/pages/home/DigitalMarketing"
import Change from "../components/pages/home/Change"
import Methods from "../components/pages/home/Methods"
import Hero from "../components/pages/home/Hero"
import Seo from "../components/Seo"
import PartnerSlider from "../components/image-slider/PartnerSlider"
import TransformMarketing from "../components/pages/home/TransformMarketing"

export default function Home() {

  return (
    <Layout useBlackNav>
      <Hero />
      <Methods />
      <Change />
      <div className="bg-brandGrayBlue30 pb-20">
        <PartnerSlider />
      </div>
      <DigitalMarketing />
      <Advantage />
      <DynamicMarketing />
      <Success />
      <TransformMarketing />
    </Layout>
  )
}

export const Head = () => <Seo />